export const THEME_KEY = 'mantraz_auth_theme';
export const THEME_ATTR = 'data-auth-theme';

// apa pun yang gak dikenal jatuh ke terang, karena seluruh aplikasi terang
export function normalizeTheme(value) {
  return value === 'dark' ? 'dark' : 'light';
}

export function oppositeTheme(value) {
  return normalizeTheme(value) === 'dark' ? 'light' : 'dark';
}

export function readStoredTheme() {
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_KEY));
  } catch (error) {
    return 'light';
  }
}

export function writeStoredTheme(theme) {
  try {
    window.localStorage.setItem(THEME_KEY, normalizeTheme(theme));
  } catch (error) { /* mode privat */ }
}

export function applyTheme(theme) {
  const next = normalizeTheme(theme);
  document.documentElement.setAttribute(THEME_ATTR, next);
  writeStoredTheme(next);
  return next;
}
